<template>
<div class="app-version">
  <div class="app-version-body">
    <el-form class="version-form" :inline="true" :model="appDesignPackage" label-position="left" label-width="100px">
        <el-row>
        <el-col :span="12">
          <el-form-item label="版本号">
            <el-input v-model="appDesignPackage.appVersion" disabled></el-input>
          </el-form-item>
          <el-form-item label="系统类型">
            <el-select v-model="appDesignPackage.appType" disabled>
              <el-option label="ios" value="ios"></el-option>
              <el-option label="安卓" value="android"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="链接">
            <el-input type="textarea" v-model="appDesignPackage.appApkPath" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否展示">
            <el-select v-model="appDesignPackage.isShow">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="版本名称">
            <el-input v-model="appDesignPackage.appVersion" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否可用">
            <el-select v-model="appDesignPackage.isUse">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="更新信息">
            <el-input type="textarea" v-model="appDesignPackage.versionDescription"></el-input>
          </el-form-item>
          <el-form-item label="是否强制升级">
            <el-select v-model="appDesignPackage.mandatoryUpgrade">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row class="bottons">
        <el-col :span="24">
          <el-form-item class="sub-button">
              <el-button type="primary" @click="save()">保存</el-button>
              <el-button  @click="cancel()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
    </el-form>
  </div>
  </div>

</template>
<script>
import _ from 'lodash'
export default {
  props: ['id'],
  data () {
    return {
      appDesignPackage: {
        id: this.id,
        appVersion: '',
        appType: 'ios',
        appApkPath: '',
        isShow: '',
        isUse: '',
        versionDescription: '',
        mandatoryUpgrade: ''
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.loading = true
      this.$axios.get(`/mobile-api/version/${this.id}`)
        .then((res) => {
          res.data.appType = res.data.appType === 1 ? 'android' : 'ios'
          res.data.isShow = res.data.isShow === true ? '1' : '0'
          res.data.isUse = res.data.isUse === true ? '1' : '0'
          res.data.mandatoryUpgrade = res.data.mandatoryUpgrade === true ? '1' : '0'
          this.appDesignPackage = res.data
        })
    },
    save () {
      let newAppVersion = _.cloneDeep(this.appDesignPackage)
      newAppVersion.appType = newAppVersion.appType === 'android' ? 1 : 2
      newAppVersion.isShow = newAppVersion.isShow === '1'
      newAppVersion.isUse = newAppVersion.isUse === '1'
      newAppVersion.mandatoryUpgrade = newAppVersion.mandatoryUpgrade === '1'
      this.$axios.post(`/mobile-api/version`, newAppVersion)
        .then(res => {
          this.$emit('closeDialog', 'save')
        })
    },
    cancel () {
      this.$emit('closeDialog', 'cancel')
    }
  }
}
</script>
<style lang="scss">
.app-version {
   height: 100%;
   padding: 10px;
  .app-version-body {
    background: #fff;
    -webkit-box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
    box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
    border-radius: 4px 0;
    height: 100%;
    .title{
      height: 35px;
      line-height: 35px;
      color: #232323;
      padding-left: 10px;
      border-bottom: 1px solid #ededed;
    }
    .version-form {
    width: 760px;
    margin: 28px auto;
    .el-form-item--mini .el-form-item__label {
      font-size: 12px;
    }
    input,textarea {
      width: 238px;
    }
    }
    .bottons {
      margin-top: 98px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/appDesign/app-version.vue